import React from "react";
import { useTranslation } from "react-i18next";
import BluePenIcon from "../../../../assets/icons/blue-pen.svg";
import "./EditCategoriesHelpModal.less";

export type EditCategoriesHelpModalProps = {
  onClose: () => void;
};

const EditCategoriesHelpModal: React.FC<EditCategoriesHelpModalProps> = ({ onClose }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => {
    onClose?.();
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="edit-categories-help-bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="edit-categories-help-bottom-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="edit-categories-help-bottom-modal-container">
          <img src={BluePenIcon} className="edit-categories-help-bottom-modal-icon" alt="Edit" />
          <div className="edit-categories-help-bottom-modal-title">{t("edit-categories-help-desc")}</div>
          <button className="edit-categories-help-bottom-modal-accept-button" onClick={onClose}>
            {t("i-understand")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCategoriesHelpModal;
